var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var ProjectInvoiceAPI = /** @class */ (function (_super) {
    __extends(ProjectInvoiceAPI, _super);
    function ProjectInvoiceAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectInvoiceAPI.prototype.list = function (props) { return this.fetchPaginated("/api/project-invoice/list", props); };
    ProjectInvoiceAPI.prototype.remove = function (props) { return this.fetcher.post("/api/project-invoice/remove", props); };
    ProjectInvoiceAPI.prototype.insert = function (props) { return this.fetcher.post("/api/project-invoice/create", props); };
    ProjectInvoiceAPI.prototype.update = function (props) { return this.fetcher.post("/api/project-invoice/update", props); };
    return ProjectInvoiceAPI;
}(SubAPI));
export { ProjectInvoiceAPI };
